import React from "react";
import {
  getTheme,
  initializeIcons,
  loadTheme,
  registerOnThemeChangeCallback,
  removeOnThemeChangeCallback
} from "@fluentui/react";
import fluentUITheme from "../../static/themes/fluentUI.json";
import ceriosBlueTheme from "../../static/themes/ceriosBlue.json";
import ceriosOrangeTheme from "../../static/themes/ceriosOrange.json";

export const AllThemes = {
  default: fluentUITheme,
  ceriosOrange: ceriosOrangeTheme,
  ceriosBlue: ceriosBlueTheme
};

export const loadThemeByName = (themeName) => {
  if (AllThemes[themeName]) {
    loadTheme(AllThemes[themeName]);
  }
};

const defaultUserPrefs = {
  locale: "nl_NL",
  theme: "ceriosBlue"
};

export const initializeUI = () => {
  initializeIcons();
  registerOnThemeChangeCallback((theme) => document.documentElement.style.background = theme.semanticColors.bodyBackground);

  const userPrefs = { ...defaultUserPrefs };
  for (const key in defaultUserPrefs) {
    let storedItem = globalThis.localStorage.getItem(key);
    // Convert 'valori-themes' for backward-compatibility.
    if (key === "theme") {
      if (storedItem === "valoriBlue") {
        storedItem = "ceriosBlue";
        globalThis.localStorage.setItem(key, storedItem);
      } else if (storedItem === "valoriOrange") {
        storedItem = "ceriosOrange";
        globalThis.localStorage.setItem(key, storedItem);
      }
    }
    userPrefs[key] = storedItem || userPrefs[key];
  }
  return userPrefs;
};

export const useTheme = () => {

  const [theme, setTheme] = React.useState(getTheme());

  React.useEffect(() => {
    registerOnThemeChangeCallback(setTheme);
    return () => removeOnThemeChangeCallback(setTheme);
  }, []);

  return {
    theme,
    semanticColors: theme.semanticColors,
    viewPaneBackground: theme.palette.neutralLighter,
    editPaneBackground: theme.palette.neutralLighterAlt,
    markHighlightBackground: theme.semanticColors.markHighlightBackground || theme.palette.greenLight,
    ceriosBlue: "#211959",
    ceriosYellow: "#F29100"
  };
};